import { useState } from 'react';
import API_CONFIG from '../config/api';
import './AdminLoginPage.css'; // Reusing styles but adding a class for overrides

function SuperAdminLoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const logoSrc = `${process.env.PUBLIC_URL || ''}/Png-01.png`;

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        if (!email || !password) {
            setError('Please provide full security identifiers.');
            return;
        }

        setIsLoading(true);

        try {
            // Determine API URL (fallback to localhost:5002 if not provided)
            const apiUrl = `${API_CONFIG.BASE_URL}/api/admin/login`;

            console.log(`📡 Connecting to Neural Core at ${apiUrl}...`);

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                setIsLoading(false);
                setError(data.message || 'Verification failed. Credentials rejected.');
                console.error('🔒 Access Denied:', data.message);
                return;
            }

            // Triple-check role for extra security
            if (data.data.role !== 'super_admin') {
                setIsLoading(false);
                setError('Unauthorized Identity. This terminal is restricted to Neural Core Administrators.');
                return;
            }

            const sessionData = {
                ...data.data,
                loginTime: Date.now(),
                expiresAt: Date.now() + (2 * 60 * 60 * 1000) // 2 hour high-level session
            };

            localStorage.setItem('adminSession', JSON.stringify(sessionData));
            setIsLoading(false);

            // Pulse effect before redirect
            console.log('🌌 Access Granted. Synchronizing Neural core...');
            window.location.href = '/admin/super-dashboard';

        } catch (error) {
            setIsLoading(false);
            setError('Connection Terminated. Neural Core is unreachable. Check backend status.');
            console.error('📡 Discovery Error:', error);
        }
    };

    return (
        <div className="admin-login-page super-admin-theme">
            <div className="admin-login-main">
                <div className="admin-login-card super-admin-card">
                    <div className="admin-login-logo">
                        <img src={logoSrc} alt="E-Fin Logo" />
                    </div>

                    <h1 className="admin-page-title">Super Admin Portal</h1>
                    <p className="admin-subtitle">Enterprise Gateway & System Configuration</p>

                    {error && (
                        <div className="admin-alert">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="8" x2="12" y2="12"></line>
                                <line x1="12" y1="16" x2="12.01" y2="16"></line>
                            </svg>
                            <span>{error}</span>
                        </div>
                    )}

                    <form onSubmit={handleLogin} className="admin-form">
                        <div className="admin-input-group">
                            <label htmlFor="email">Security Identifier (Email)</label>
                            <div className="input-with-icon">
                                <div className="input-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                        <polyline points="22,6 12,13 2,6"></polyline>
                                    </svg>
                                </div>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="superadmin@efin.com"
                                    disabled={isLoading}
                                    required
                                />
                            </div>
                        </div>

                        <div className="admin-input-group">
                            <label htmlFor="password">Vault Access Password</label>
                            <div className="input-with-icon">
                                <div className="input-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                    </svg>
                                </div>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    disabled={isLoading}
                                    required
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={isLoading}
                                >
                                    {showPassword ? '🙈' : '👁️'}
                                </button>
                            </div>
                        </div>

                        <button type="submit" className="admin-login-btn super-btn" disabled={isLoading}>
                            {isLoading ? 'Verifying Credentials...' : 'Access Neural Core'}
                        </button>
                    </form>

                    <div className="admin-login-footer">
                        <p>Standard Admin? <a href="/admin/login">Switch to Staff Portal</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SuperAdminLoginPage;
